import { render, staticRenderFns } from "./homeTwo.vue?vue&type=template&id=42144f59&scoped=true&"
import script from "./homeTwo.vue?vue&type=script&lang=js&"
export * from "./homeTwo.vue?vue&type=script&lang=js&"
import style0 from "./homeTwo.vue?vue&type=style&index=0&id=42144f59&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42144f59",
  null
  
)

export default component.exports